<template lang="pug">
el-container#app.is-vertical
  AdminHeader
  el-container
    AdminSidebar
    router-view
</template>

<script>
import AdminHeader from '@/components/AdminHeader';
import AdminSidebar from '@/components/AdminSidebar';

export default {
  components: {
    AdminHeader,
    AdminSidebar,
  },
};
</script>


<style lang="stylus" scoped>
#app
  height 100vh
  width 100vw
</style>



// WEBPACK FOOTER //
// src/components/layouts/LayoutAdmin.vue